import React from 'react';
import axios from "axios";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setPageTitle } from "../../app/actions";
import { getJwtToken } from '../Common/Auth';
import { getApiURL } from "../Common/envVarsReader";
import JobDetailsPanel from "./JobDetailPanel";
import JobArtifactPanel from "./JobArtifactPanel";
import JobJiraPanel from "./JobJiraPanel";
import JobClosurePanel from "./JobClosurePanel";

/**
 * Parses the --mode value from a job's parameter string.
 */
function parseJobMode(params) {
    if (!params) return null;
    const parts = params.split(' ');
    for (let i = 0; i < parts.length; i++) {
        if (parts[i] === '--mode' && i + 1 < parts.length) {
            return parts[i + 1].trim();
        }
    }
    return null;
}

export default function JobDetailPage() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [jobMode, setJobMode] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        dispatch(setPageTitle('Job - ' + id));
        loadJobMode(id);
    }, [id]);

    const loadJobMode = async (id) => {
        setLoading(true);
        const options = {
            headers: {
                'Authorization': `Bearer ${getJwtToken()}`,
                'Content-Type': 'application/json'
            },
        };

        try {
            const response = await axios.get(`${getApiURL()}/job?id=${id}`, options);
            const mode = parseJobMode(response['data']['parameters']);
            setJobMode(mode);
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    };

    return (
        <div>
            <JobDetailsPanel id={id} />
            <br/>
            <JobArtifactPanel id={id} />
            <br/>
            {!loading && (
                jobMode === 'close-tickets'
                    ? <JobClosurePanel id={id} />
                    : <JobJiraPanel id={id} />
            )}
        </div>
    );
}
